import styled from "styled-components";
import { Container } from "react-bootstrap";
import { StyledBackButton } from "../../login/loginStyled";

export const StyledContainer = styled(Container)`
  max-width: ${({ $width }) => ($width ? $width : "870px")};
  min-height: ${({ $height }) => $height};
  background: var(--white-color);
  box-shadow: var(--box-shadow1);
  border-radius: 12px;
  @media screen and (max-width: 992px) {
    width: 90%;
  }
  .title {
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: var(--blue-color-dark);
  }
`;
export const StyledArrowBack = styled(StyledBackButton)`
  position: static;
`;
